export class OrderCountsDTO{
    public pending = 0;
    public processing = 0;
    public complete = 0;
    public canceled = 0;
}

export default class OrderCounts extends OrderCountsDTO {
    constructor(dto?: OrderCountsDTO) {
        super();
        if (dto) {
            Object.assign(this, dto);
        }
    }
}